import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a5632bb2cc25000145f4535_1787265424583_fa9059f0/ideandres/src/app/page.tsx");
